import styles from "./WaysToStyleCarousel.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

export interface WaysToStyleLook {
  id: number;
}

interface WaysToStyleCarouselProps {
  stylingLooks: { products: WaysToStyleLook[] }[];
}

export default function WaysToStyleCarousel({
  stylingLooks,
}: WaysToStyleCarouselProps) {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  if (stylingLooks.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="waysToStyleCarousel"
      className={styles.carousel}
      aria-label={getTranslation("pdp_buy_the_look_carousel_accessibility")}
    >
      {stylingLooks.map((look, index) => (
        <div key={`${look.products[0]?.id}-${index}`} className={styles.carouselItem}>
          <div className={styles.mainImage} />
          <div className={styles.thumbnailContainer}>
            {look.products?.map((lookProduct, index) => (
              <div key={`${lookProduct?.id}-${index}`} className={styles.thumbnail} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
